import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ScopedBlockLabels, useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import {
    LabelSeverity, LabelWithNamedArguments,
} from '@/storecontext/shared/api/server-apis';
import { computed, ComputedRef } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLabelWithNamedArguments',
  props: {
    label: null,
    namespace: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { label: LabelWithNamedArguments, namespace: ScopedBlockLabels }



const labels = useBlockLabels(props.namespace);
const formattedHtml: ComputedRef<string> = computed(() => dictionaryService.formatNamed(labels[props.label.label], props.label.namedParams));
const isErrorColor: ComputedRef<boolean> = computed(() => props.label.severity === LabelSeverity.Warning);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'text-roman': _unref(isErrorColor) }),
    innerHTML: _unref(formattedHtml)
  }, null, 10, _hoisted_1))
}
}

})